import React, { useState, useEffect } from 'react';
import { Box, styled, List, ListItem, ListItemText,Typography } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useNavigate, useLocation } from 'react-router-dom';
import Billing from '../Components/Billing';
import Complaints from '../Components/Complaints';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../redux/permissionsSlice';


const StyledTabs = styled(Tabs)({
  backgroundColor: '#e1e7ef',
  borderRadius: '10px',
  padding: '4px',
  '& .MuiTabs-indicator': {
    display: 'none',
  },
});

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '14px',
  minHeight: '36px',
  padding: '8px 16px',
  borderRadius: '5px',
  color: theme.palette.text.secondary,
  '&.Mui-selected': {
    color: '#fff',
    backgroundColor: '#635bff',
  },
}));


const Billings = () => {
 
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = useSelector(selectPermissions);
  
  const hasModulePermission = (moduleName) => {
    const modulePermission = permissions.find(permission => permission.ModuleName === moduleName);
    if (!modulePermission) return false;
    
    return Object.entries(modulePermission).some(([key, value]) => 
      ['AddRec', 'EditRec', 'DeleteRec', 'ViewRec'].includes(key) && value === "1"
    );
  }

  const allTabs = [
    { label: "Complaint", path: "/service&ticket/complaint", component: Complaints, moduleName: 'Complaint' },
    { label: "Billing", path: "/service&ticket/billing", component: Billing ,moduleName: 'Billing'}
  ];

 

  const tabs = allTabs.filter((tab) => hasModulePermission(tab.moduleName));
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    // Redirect to the first tab if the path is '/billings'
    if (location.pathname === '/service&ticket' && tabs.length > 0) {
      navigate(tabs[0].path, { state: { permissions }, replace: true });
      setActiveTab(0);
      return;
    }

    // Handle active tab selection based on URL
    const currentTabIndex = tabs.findIndex(
      (tab) => tab.path === location.pathname
    );
    if (currentTabIndex !== -1) {
      setActiveTab(currentTabIndex);
    } else if (tabs.length > 0) {
      navigate(tabs[0].path, { state: { permissions }, replace: true });
      setActiveTab(0);
    }
  }, [location.pathname, tabs.length, permissions]);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
    navigate(tabs[newValue].path, { state: { permissions } });
  };
  if (tabs.length === 0) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h6">
          No billing sections are available based on your permissions.
        </Typography>
      </Box>
    );
  }

  const ActiveComponent = tabs[activeTab]?.component || tabs[0]?.component;

  return (
    <Box
      sx={{
        width: '100%',
        p: 2,
        '& .MuiTabs-root': {
          padding: '7px 4px 0px 4px !important',
        },
      }}
    >
      <Box sx={{ mb: 4 }}>
        <StyledTabs value={activeTab} onChange={handleChange}>
          {tabs.map((tab, index) => (
            <StyledTab key={index} label={tab.label} />
          ))}
        </StyledTabs>
      </Box>
      <Box>
        {ActiveComponent && <ActiveComponent permissions={permissions} />}
      </Box>
    </Box>
  );
};

export default Billings;